import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppUserState } from '../shared/store/user/user.store';

export const AppGuard: CanActivateFn = (route, state) => {
  const userStore = inject(Store<AppUserState>);
  const router = inject(Router);
  var IsLoggedIn:boolean = false;
  userStore.select((state) => state.loggedInUser.user)
    .subscribe(user => {      
      IsLoggedIn = user.token!=''
    });

  if(IsLoggedIn)
  {
    return true;
  }
  else{
    router.navigate(['/']);
    return false;
  } 
};